import ConditionalRender from "components/atoms/conditional-render/ConditionalRender";
import { FeedbackStatus } from "../columns/leadsTableHeaders";

export const lastTenLeads = (
    { setModalData }: {
        setModalData?: (data: { modalType: string; data: { id: number | undefined } }) => void
    }) => {
    return [
        {
            Header: "Feedback Date",
            accessor: (row: any) => row?.feedback_status_updated_at ? new Date(row?.feedback_status_updated_at) : 'feedback_date',
            Cell: ({ row }: any) => {
                
                const date = row.original.feedback_status_updated_at;
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "leads", data: { id: row.original.id } })}
                    >
                        {date ? new Date(date).toLocaleDateString("de") : "Not available"}
                    </span>
                );
            },
            id: 1,
            isChecked: true,
        },
        {
            Header: "Name",
            accessor: "info",
            Cell: ({ row }: any) => {
                
                const { first_name, last_name } = row.original.info;
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "leads", data: { id: row.original.id } })}
                    >
                        {first_name} {last_name}
                    </span>
                );
            },
            id: 3,
            isChecked: true,
        },
        {
            Header: "Birthdate",
            accessor: "info.birthdate",
            Cell: ({ row }: any) => {
                
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "leads", data: { id: row.original.id } })}
                    >
                        {row.original.info.birthdate || "Not available"}
                    </span>
                );
            },
            id: 2,
            isChecked: true,
        },
        {
            Header: "Address",
            accessor: "info.address",
            Cell: ({ row }: any) => {
                
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "leads", data: { id: row.original.id } })}
                    >
                        {row.original.info.address || "Not available"}
                    </span>
                );
            },
            id: 6,
            isChecked: true,
        },
        {
            id: 4,
            Header: "Source",
            accessor: "source",
            Cell: ({ row }: any) => {
                
                const { source } = row.original;

                if (!source || (!source.name && !source.logo)) {
                    return (
                        <span
                            className="cursor-pointer"
                            onClick={() => setModalData && setModalData({ modalType: "leads", data: { id: row.original.id } })}
                        >
                            Not available
                        </span>
                    );
                }

                return (
                    <div
                        className="flex flex-row items-center gap-2 cursor-pointer"
                        
                    >
                        <ConditionalRender condition={source.logo?.length > 0}>
                            <img
                                loading="lazy"
                                className="object-fit rounded-full w-[30px] h-[30px]"
                                src={`https://mainhub.insuhub.ch/api/leads/sources/get-logo/${source.logo}`}
                                alt="Logo"
                            />
                        </ConditionalRender>
                        <div>{source.name}</div>
                    </div>
                );
            },
            isChecked: true,
        },
        {
            Header: `Status`,
            accessor: (row: any) => row?.feedback_status || `Not available`,
            Cell: ({ row, value }: any) => {
                
                return (
                    <div
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "leads", data: { id: row.original.id } })}
                    >
                        <FeedbackStatus value={value} />
                    </div>
                );
            },
            id: 5,
            isChecked: true,
        }
    ];
}
